export default __webpack_public_path__ + "static/media/pic_3.440e4b42.png";